import { IFactura } from './../models/iFactura';
import { ROUTE_COMERCIAL } from './../constants/constant.model';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FacturaService {

  constructor(private apiService: ApiService,
    private http: HttpClient) {
  }

  insertarFactura(data: IFactura): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudFactura);
    return this.apiService.executePostJson(data).pipe();
  }

  insertarFacturaPuntodeventaV2(data: IFactura): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudFactura+'/v2');
    return this.apiService.executePostJson(data).pipe();
  }

  actualizarFactura(data: IFactura): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudFactura);
    return this.apiService.executePutJson(data).pipe();
  }

  obtenerFactura(numint: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudFactura);
    return this.apiService.execGetQueryJson(`/${numint}`).pipe();
  }

  anularFactura(data: IFactura): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.anularFactura);
    return this.apiService.executePostJson(data).pipe();
  }

  public anular(numint: number, coduser: string) {
    return this.http.put(environment.serviceUrl + "factura/" + numint + "/anular?coduser=" + coduser, null, { observe: 'response' },)
  }

  public eliminar(numint: number, coduser: string) {
    return this.http.put(environment.serviceUrl + "factura/" + numint + "/eliminar?coduser=" + coduser, null, { observe: 'response' },)
  }

  calcularFactura(data: IFactura): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.calcularFactura);
    return this.apiService.executePutJson(data).pipe();
  }

  buscarFactura(situac: string, codsuc: number, codcli: string, fdesde: string, fhasta: string, limit: number, offset: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudFactura + '/buscar');
    return this.apiService.execGetQueryJson(`?situac=${situac}&codsuc=${codsuc}&codcli=${codcli}&fdesde=${fdesde}&fhasta=${fhasta}&limit=${limit}&offset=${offset}`).pipe();
  }

  buscarFacturaParaGuias(femisi: any, moneda: string, codsuc: number, codcli: string): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudFactura + '/buscar/facturas-para-guias');
    return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
  }

   download_pdf(_formato: number, numint: number, cia: string) {
    let fullUrl: any = null;
    if (_formato == 1) //A4
      fullUrl = environment.serviceUrl_Report + `factura/${numint}/report/public/format-a4.pdf?` + "cia=" + cia;
    if (_formato == 2) //ticket
      fullUrl = environment.serviceUrl_Report + `factura/${numint}/report/public/format-ticket.pdf?` + "cia=" + cia;
    if (_formato == 3) //defecto
      fullUrl = environment.serviceUrl_Report + `factura/${numint}/report/public/format-default.pdf?` + "cia=" + cia;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

  download_pdfAgrup(_formato: number, numint: number, cia: string,agrupado:any) {
    let fullUrl: any = null;
    if (_formato == 1)
      fullUrl = environment.serviceUrl_Report + `factura/${numint}/report/public/format-1.pdf?` + "cia=" + cia+ `&agrupado=${agrupado}`;
    if (_formato == 2)
      fullUrl = environment.serviceUrl_Report + `factura/${numint}/report/public/format-ticket.pdf?` + "cia=" + cia+ `&agrupado=${agrupado}`;
    if (_formato == 3)
      fullUrl = environment.serviceUrl_Report + `factura/${numint}/report/public/format-default.pdf?` + "cia=" + cia+ `&agrupado=${agrupado}`;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

  download_pdf_packing_lista( numint: number) {
    let fullUrl: any = null;
      fullUrl = environment.serviceUrl_Report + `trazabilidad/reporte/packing-list-lavanderia/pdf?` + "numint=" + numint;
    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

 

  public buscarDocumentosPendientesEnvioSunat(id_cia: number, fdesde: any, fhasta: any) {
    return this.http.get(environment.serviceUrl_FE + "consulta/factura/" + id_cia + "?fdesde=" + fdesde + "&fhasta=" + fhasta, { observe: 'response' },)
  }

  buscarFacturaParaDevolucion(femisi: any, moneda: string, codsuc: number, codcli: string): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudFactura + '/buscar/facturas-para-devolucion');
    return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
  }

}